import { Directive, AfterViewInit } from '@angular/core';
import Inputmask from 'inputmask';
import { DatePicker } from 'primeng/datepicker';
@Directive({
  selector: '[dateMask]',
  standalone: true
})
export class DateMaskDirective implements AfterViewInit {
  constructor(private readonly primeCalendar: DatePicker) { }

  ngAfterViewInit() {
    new Inputmask( this.getDateMask() ).mask( this.getHTMLInput() );
  }

  getHTMLInput(): HTMLInputElement {
    return this.primeCalendar.el.nativeElement.querySelector('input');
  }

  getDateMask(): string {
    if(this.primeCalendar.timeOnly) {
      return '99:99';
    } else if(this.primeCalendar.showTime) {
      return '99-99-9999 99:99';
    } else {
      return '99-99-9999';
    }
  }
}
